import React from "react";

import "./policy.css";
import badmintonBg from "../../../assets/home-bg.jpg";

function PolicyScreen() {
  return (
    <>
      <header
        className="masthead"
        style={{
          backgroundImage: `url(${badmintonBg})`,
        }}
      >
        <div className="container position-relative px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <div className="site-heading">
                <h1>Privacy Policy</h1>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="container px-4 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center">
          <div className="col-md-10 col-lg-8 col-xl-7">
            <div className="post-preview">
              <h2 className="post-title">Privacy</h2>
              <p className="mb-4">
                Welcome to <strong>Nishjesh Sports AI</strong> (“we,” “our,”
                “us”). We value your privacy and are committed to protecting
                your personal information. This Privacy Policy explains how we
                collect, use, and share information when you visit or interact
                with our website, <a href="https://nishjeshsports-ai.com">nishjesh.com</a> (the “Site”),
                and any related products, applications, or services
                (collectively, the “Services”). By using our Site, you agree to
                the terms of this Privacy Policy.
              </p>

              <h2>1. Information We Collect</h2>
              <div className="section">
                <p>We may collect the following categories of information:</p>

                <h3 style={{ marginTop: "12px", marginBottom: "6px" }}>
                  a. Personal Information
                </h3>
                <p>
                  When you interact with our Site, such as signing up for
                  updates, requesting a demo, or contacting us, we may collect:
                </p>
                <ul>
                  <li>Name, email address, and phone number</li>
                  <li>Organization or team name (if applicable)</li>
                  <li>
                    Login credentials (if account-based access is provided)
                  </li>
                  <li>
                    Payment or billing details (processed securely via
                    third-party providers)
                  </li>
                </ul>

                <h3 style={{ marginTop: "12px", marginBottom: "6px" }}>
                  b. Usage Data and Technical Information
                </h3>
                <p>
                  We automatically collect certain data to help improve our
                  analytics platform, such as:
                </p>
                <ul>
                  <li>
                    IP address, browser type, device type, and operating system
                  </li>
                  <li>
                    Pages visited, time spent, referring URLs, and clickstream
                    data
                  </li>
                  <li>
                    General location (city or region, not precise GPS location)
                  </li>
                </ul>

                <h3 style={{ marginTop: "12px", marginBottom: "6px" }}>
                  c. Cookies and Tracking Technologies
                </h3>
                <p>
                  We use cookies and similar technologies to enhance your
                  experience, analyze traffic, and personalize content. You may
                  control or disable cookies through your browser settings.
                </p>
              </div>

              <h2>2. How We Use Your Information</h2>
              <div className="section">
                <p>We use collected data to:</p>
                <ul>
                  <li>
                    Deliver and improve our AI-powered sports analytics platform
                  </li>
                  <li>Personalize insights and recommendations</li>
                  <li>Process transactions and maintain user accounts</li>
                  <li>Respond to your questions or requests</li>
                  <li>
                    Send service-related or promotional communications (if you
                    opt in)
                  </li>
                  <li>Maintain security and prevent fraud</li>
                  <li>Comply with applicable laws and regulations</li>
                </ul>
              </div>

              <h2>3. How We Share Your Information</h2>
              <div className="section">
                <p>We may share your data with:</p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> vendors that assist with
                    hosting, analytics, payments, or communications
                  </li>
                  <li>
                    <strong>Business Partners:</strong> if you use features
                    integrated with other sports or analytics platforms
                  </li>
                  <li>
                    <strong>Legal Requirements:</strong> when required by law,
                    subpoena, or government request
                  </li>
                  <li>
                    <strong>Business Transfers:</strong> in case of a merger,
                    sale, or acquisition of our business assets
                  </li>
                </ul>
                <p className="note">
                  <strong>We do not sell your personal information.</strong>
                </p>
              </div>

              <h2>4. Data Retention and Security</h2>
              <div className="section">
                <p>
                  We retain your information only as long as necessary to
                  fulfill the purposes described in this policy. We employ
                  industry-standard safeguards (including encryption, secure
                  data centers, and restricted access) to protect your data.
                  However, no online transmission is 100% secure.
                </p>
              </div>

              <h2>5. Your Privacy Rights</h2>
              <div className="section">
                <p>Depending on your location, you may have the right to:</p>
                <ul>
                  <li>Access, correct, or delete your data</li>
                  <li>
                    Withdraw consent or opt out of marketing communications
                  </li>
                  <li>Request data portability</li>
                </ul>
                <p className="note">
                  To exercise these rights, contact us at{" "}
                  <a href="mailto:support@nishjeshsports-ai.com">
                    support@nishjeshsports-ai.com
                  </a>
                  .
                </p>
                <p className="note">
                  If you reside in California, you have additional rights under
                  the California Consumer Privacy Act (CCPA) — see Section 10
                  below.
                </p>
              </div>

              <h2>6. Children's Privacy</h2>
              <div className="section">
                <p>
                  Our services are intended for users aged 13 and older. We do
                  not knowingly collect information from children under 13. If
                  we discover such data, we will delete it promptly.
                </p>
              </div>

              <h2>7. Third-Party Links</h2>
              <div className="section">
                <p>
                  Our Site may contain links to third-party websites or
                  services. We are not responsible for the content, security, or
                  privacy practices of those external sites.
                </p>
              </div>

              <h2>8. International Users</h2>
              <div className="section">
                <p>
                  Our servers are located in the United States. If you access
                  our Site from outside the U.S., you consent to the transfer
                  and processing of your data in the U.S. under this Privacy
                  Policy.
                </p>
              </div>

              <h2>9. Updates to This Policy</h2>
              <div className="section">
                <p>
                  We may update this Privacy Policy periodically to reflect
                  changes in our practices or for legal reasons. The updated
                  version will be posted on this page with a revised “Last
                  Updated” date.
                </p>
              </div>

              <h2>10. California Privacy Notice (CCPA)</h2>
              <div className="section">
                <p>If you are a California resident, you have the right to:</p>
                <ul>
                  <li>
                    Request details about the personal information we collect
                    and how we use it
                  </li>
                  <li>Request deletion of your personal information</li>
                  <li>
                    Opt out of any sale of data (we do not sell personal data)
                  </li>
                </ul>
                <p className="note">
                  You can exercise your rights by emailing{" "}
                  <a href="mailto:support@nishjeshsports-ai.com">
                    support@nishjeshsports-ai.com
                  </a>
                  . We will verify your identity before processing your request
                  and will not discriminate against you for exercising your
                  privacy rights.
                </p>
              </div>

              <h2>11. Contact Us</h2>
              <div>
                <p>
                  If you have any questions, concerns, or requests about this
                  Privacy Policy or our data practices, please contact us at:
                </p>
                <ul>
                  <li>
                    <strong>Nishjesh Sports AI</strong>
                  </li>
                  <li>
                    Email:{" "}
                    <a href="mailto:support@nishjeshsports-ai.com">
                      support@nishjeshsports-ai.com
                    </a>
                  </li>
                  <li>
                    Website:{" "}
                    <a
                      href="https://nishjeshsports-ai.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://nishjeshsports-ai.com
                    </a>
                  </li>
                </ul>
              </div>

              <footer>
                <p>
                  &copy; <span id="currentYear"></span> Nishjesh Sports AI — All
                  Rights Reserved.
                </p>
              </footer>
            </div>
            <hr className="my-4" />
          </div>
        </div>
      </div>
    </>
  );
}

export default PolicyScreen;
